import { filter as lodashFilter, sortBy } from 'lodash';
import {
  FormOption,
  ReturnFilterForm,
  ReturnSearchForm,
  ReturnSearchType,
} from 'types';
import { getFinalDate, getInitialDate } from 'helpers/date';
import { RETURN_STATUSES } from 'commons/return-statuses';

export const storeReturnStatuses = lodashFilter(RETURN_STATUSES, {
  storeFilter: true,
});

const formattedReturnStatuses = storeReturnStatuses.map(({ label, value }) => ({
  label,
  value,
}));

export const returnStatuses: FormOption[] = sortBy(formattedReturnStatuses, [
  'label',
]);

const DEFAULT_RETURN_SEARCH: ReturnSearchForm = {
  searchType: ReturnSearchType.Codes,
  codes: '',
  cpf: '',
  filterDate: '',
  customerName: '',
};

export function getDefaultReturnSearch(): ReturnSearchForm {
  return {
    ...DEFAULT_RETURN_SEARCH,
    filterDate: new Date().toDateString(),
  };
}

const DEFAULT_RETURN_FILTER: ReturnFilterForm = {
  startDate: getInitialDate({ timeDifference: 30 }),
  endDate: getFinalDate(),
  returnStatuses: storeReturnStatuses
    .filter(({ initialStoreFilter }) => initialStoreFilter)
    .map(({ value }) => value)
    .sort(),
  filterDate: '',
};

export function getDefaultReturnFilter(): ReturnFilterForm {
  return {
    ...DEFAULT_RETURN_FILTER,
    startDate: getInitialDate({ timeDifference: 30 }),
    endDate: getFinalDate(),
    filterDate: new Date().toDateString(),
  };
}
